import { render, staticRenderFns } from "./currencyPicker.vue?vue&type=template&id=139549cb&scoped=true&"
import script from "./currencyPicker.vue?vue&type=script&lang=js&"
export * from "./currencyPicker.vue?vue&type=script&lang=js&"
import style0 from "./currencyPicker.vue?vue&type=style&index=0&id=139549cb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139549cb",
  null
  
)

export default component.exports